import React from 'react'
import PropTypes from 'prop-types'
import Svg from 'src/Components/shared/Svg'

const HouseSvg = ({ className }) => (
  <Svg
    className={className}
    width='63'
    height='53'
    viewBox='0 0 63 53'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M62.1111 31.6296L50.6528 20.5185V3.85185H43.0139V13.1111L31.5556 2L1 31.6296V33.4815H8.63889V52H27.7361V40.8889H35.375V52H54.4722V33.4815H62.1111V31.6296Z'
      stroke='#9D97A6'
      strokeWidth='1.5'
    />
  </Svg>
)

HouseSvg.propTypes = {
  className: PropTypes.string
}

export default HouseSvg
